import { Paragraph } from '@quickmd-llc/design-system';
import { Events, tracking } from '@lib';
import TimeOfDayButton from './TimeOfDayButton';
import HoursButtonGrid from './HoursButtonGrid';
import { useFilters } from '../useFilters';
import { TimeOfDay } from '../filtersTypes';

export default function TimeOfDayButtons(): JSX.Element {
  const { setHour, setTimeOfDay, timeOfDay } = useFilters();

  function handleOnClick(newTimeOfDay: TimeOfDay) {
    tracking.trackEvent(Events.FILTER_BY_TIME_OF_DAY, {
      Range: newTimeOfDay,
    });

    if (newTimeOfDay === timeOfDay) {
      return setTimeOfDay(null);
    }

    setHour(null);
    setTimeOfDay(newTimeOfDay);
  }

  return (
    <div className="w-full">
      <Paragraph className="mb-2 font-semibold text-text-dark">
        Time of day
      </Paragraph>

      <div className="grid gap-2">
        <div className="grid w-full grid-cols-3">
          <TimeOfDayButton
            timeOfDay={TimeOfDay.MORNING}
            onClick={handleOnClick}
          />
          <TimeOfDayButton
            timeOfDay={TimeOfDay.AFTERNOON}
            onClick={handleOnClick}
          />
          <TimeOfDayButton
            timeOfDay={TimeOfDay.EVENING}
            onClick={handleOnClick}
          />
        </div>

        {timeOfDay && <HoursButtonGrid />}
      </div>
    </div>
  );
}
